export module urlHelper {
  export const formateURL = (url: string) => url.replace(/^https?:\/\//, '')
}
